import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { getPaidUserManagementUrl } from 'self-service-api/core/utilities/links';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { AssignSeatButtonPropsInterface } from 'ui-addon-upgrades/button/interfaces/requestAssignSeatButtonInterface';
import { getUpgradeDataTrackingProperties, trackPotentialBannerInteraction } from 'ui-addon-upgrades/ums/utils';
import { omit } from 'ui-addon-upgrades/utils';
import ErrorBoundary from '../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignSeatButton = props => {
  const {
    upgradeData,
    level,
    usageLimitBannerData
  } = props;
  const propsToPass = omit(props, 'isUpgradePoint', 'upgradeData', 'location', 'subscreen', 'level', 'usageLimitBannerData');
  useEffect(() => {
    tracker.track('interaction', Object.assign({
      action: 'viewed assign seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, getUpgradeDataTrackingProperties(upgradeData, true, false, !!upgradeData.apiName)));
  }, [upgradeData, usageLimitBannerData, level]);
  const trackClick = () => {
    tracker.track('interaction', Object.assign({
      action: 'clicked upgrade point'
    }, usageLimitBannerData, getUpgradeDataTrackingProperties(upgradeData, true, false, !!upgradeData.apiName)));
    tracker.track('interaction', Object.assign({
      action: 'clicked assign seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, getUpgradeDataTrackingProperties(upgradeData, true, false, !!upgradeData.apiName)));
    const {
      pointType,
      upgradeKey
    } = upgradeData;
    trackPotentialBannerInteraction(pointType, upgradeKey).catch(error => {
      Raven.captureException(new Error('Failed to submit interaction from UIAssignSeatButton'), {
        extra: {
          error
        }
      });
    });
  };
  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    "data-reagan-primary-cta": true,
    "data-test-id": "assign-seat-button"
  }, propsToPass, {
    href: getPaidUserManagementUrl(),
    external: true,
    onClick: trackClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.assignSeatButton"
    })
  }));
};
AssignSeatButton.propTypes = AssignSeatButtonPropsInterface;
const UIAssignSeatButton = props => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "UIAssignSeatButton",
    children: /*#__PURE__*/_jsx(AssignSeatButton, Object.assign({}, props))
  });
};
export default UIAssignSeatButton;